import { useRef } from 'react'

import ImageMenuModalStyles from '../ImageMenuModal.module.scss'

import { useConfirmModal } from 'hooks/useConfirmModal'
import { useGenerateImages } from 'components/GenerateImageDrawer/hooks/useGenerateImages'
import { useCreditUsage } from 'hooks/useCreditUsage'
import { useShowCreditsPaywall } from 'hooks/useShowCreditsPaywall'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useRootStore } from 'stores/RootStore'

import { Modal } from 'almanac-ui/Modal'
import { AiConfirmModal } from 'components/ImagePickerModal/AIGeneration/AiConfirmModal'
import { GenerateImageModalContent } from 'components/GenerateImageModal/GenerateImageModal'
import { useImageMenuContext } from '../ImageMenuContext'
import { Actions } from '../ImageMenuModal'
import { Button } from 'blaze-ui/Button'

export const AiGeneration = () => {
  const aiConfirmProvider = useConfirmModal(AiConfirmModal)
  const containerRef = useRef<HTMLDivElement>(null)
  const props = useGenerateImages({ containerRef })
  const { setProvider, toggleSelectedImage } = useImageMenuContext()
  const { usageCosts, creditsRemaining } = useCreditUsage()
  const { price, isTrackingCredits } = useShowCreditsPaywall()
  const { tierUsageStore } = useRootStore()
  const isAiImageGenerationCreditsEnabled = useFlipperFlag('ai_image_generation_credits')

  const generationCost = usageCosts?.ai_image_credits_cost ?? 0
  const costForTwoImages = generationCost * 2
  const isPaid = tierUsageStore.currentSubscription?.status === 'active'
  const hasPriceOrUpgradePath = (isPaid && !!price) || !isPaid
  const hasInsufficientCredits =
    isAiImageGenerationCreditsEnabled &&
    isTrackingCredits &&
    creditsRemaining < costForTwoImages &&
    hasPriceOrUpgradePath

  const showConfirmModalIfNecessary = async () => {
    if (props.generationSets.length > 0) {
      const confirm = await aiConfirmProvider()

      if (confirm) {
        setProvider('')
      }

      return
    }

    setProvider('')
  }

  return (
    <>
      <Modal.Header className={ImageMenuModalStyles.header} title="Generate an Image" />
      <GenerateImageModalContent
        showExamples={false}
        containerRef={containerRef}
        onConfirm={(image) => toggleSelectedImage({ ...image, provider: 'ai' })}
        hasInsufficientCredits={hasInsufficientCredits}
        generationCost={generationCost}
        onInsufficientCreditsPress={() => props.showInsufficientCreditsModal()}
        {...props}
      />
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={showConfirmModalIfNecessary}>
            Back
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Actions />
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
